<template>
  <!--
    作者：fzf
    时间：2025-09-08
    描述：产品中心-秒杀
  -->
  <div>

    <div class="common-form">秒杀设置</div>

    <el-form-item label="秒杀状态">
      <el-checkbox v-model="form.model.is_kill">开启</el-checkbox>
    </el-form-item>

    <el-form-item label="活动日期"
    prop="active_date">
      <el-date-picker
        v-model="form.model.active_date"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="活动开始日期"
        end-placeholder="活动结束日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      ></el-date-picker>
    </el-form-item>


  <el-form-item label="秒杀总抢购：">
    <el-input  type="number" min="0"  v-model="form.model.kstock_total" class="max-w460" style="width:200px">
      <template slot="append">作用进度条</template>
    </el-input>
  </el-form-item>

  <el-form-item label="秒杀剩抢购：">
    <el-input  type="number" min="0"  v-model="form.model.kstock" class="max-w460" style="width:200px">
      <template slot="append">作用进度条</template>
    </el-input>
  </el-form-item>



  </div>
</template>

<script>
export default {
  data(){
    return{
      /*时间*/
      timeVal: new Date(2016, 9, 10, 8, 0, 0),
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  // props: {
  //   form: Object
  // },
  inject: ['form']
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Datetime.vue